import React from "react"
import { SEO, Container, Text, Link } from "@src/shared/components"
import { PageLayout } from "@src/features/marketing/components"
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Box,
  AccordionPanel,
  AccordionIcon,
  Heading as HeadingChakra,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react"

const Page: React.FC = () => {
  return (
    <>
      <SEO robots="noindex, nofollow" />
      <PageLayout centerLogo simpleLayout>
        <Container>
          <Box maxW="2xl" margin="0 auto">
            <Box textAlign="center">
              <HeadingChakra fontSize="3xl" py={16}>
                Privacy Policy
              </HeadingChakra>
            </Box>

            <Text type="medium" mb={4}>
              This Privacy Policy describes how ohemabyeba.com (the “Site” or
              “we”) collects, uses, and discloses your Personal Information when
              you visit or make a purchase from the Site.
            </Text>

            <Text type="small" my={4}>
              After reviewing this policy, if you have additional questions,
              want more information about our privacy practices, or would like
              to make a complaint, please contact us by e-mail at
              ohema.eba@gmail.com or by mail using the details provided below:
              <br />
              <br />
              1190 Dundas Street East, Suite 1101, Toronto ON M4M 0C5, Canada
            </Text>

            <Accordion bg="#FFFCF7" mt={9} width="100%">
              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Collecting Personal Information
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" my={4}>
                    When you visit the Site, we collect certain information
                    about your device, your interaction with the Site, and
                    information necessary to process your purchases. We may also
                    collect additional information if you contact us for
                    customer support. In this Privacy Policy, we refer to any
                    information about an identifiable individual (including the
                    information below) as “Personal Information”. See the list
                    below for more information about what Personal Information
                    we collect and why.
                  </Text>
                  <UnorderedList>
                    <ListItem>
                      <Text type="medium" my={2} textDecoration="underline">
                        Device information
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Purpose of collection
                        </Box>
                        : to load the Site accurately for you, and to perform
                        analytics on Site usage to optimize our Site.
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Source of collection
                        </Box>
                        : Collected automatically when you access our Site using
                        cookies, log files, web beacons, tags, or pixels.
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Personal Information collected
                        </Box>
                        : shared with our processor Shopify.
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Disclosure for a business purpose
                        </Box>
                        : version of web browser, IP address, time zone, cookie
                        information, what sites or products you view, search
                        terms, and how you interact with the Site.
                      </Text>
                    </ListItem>
                    <ListItem>
                      <Text type="medium" my={2} textDecoration="underline">
                        Order information
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Purpose of collection
                        </Box>
                        : to provide products or services to you to fulfill our
                        contract, to process your payment information, arrange
                        for shipping, and provide you with invoices and/or order
                        confirmations, communicate with you, screen our orders
                        for potential risk or fraud, and when in line with the
                        preferences you have shared with us, provide you with
                        information or advertising relating to our products or
                        services.
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Source of collection
                        </Box>
                        : collected from you.
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Personal Information collected
                        </Box>
                        : shared with our processor Shopify.
                      </Text>
                      <Text type="small" pl={6}>
                        <Box as="span" fontWeight="bold">
                          Disclosure for a business purpose
                        </Box>
                        : name, billing address, shipping address, payment
                        information (including credit card numbers), email
                        address, and phone number..
                      </Text>
                    </ListItem>
                    {/* <ListItem>
                      <Text type="medium" my={2} textDecoration="underline">
                        Customer support information
                      </Text>
                    </ListItem> */}
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Minors
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    The Site is not intended for individuals under the age of
                    13. We do not intentionally collect Personal Information
                    from children. If you are the parent or guardian and believe
                    your child has provided us with Personal Information, please
                    contact us at the address above to request deletion.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Sharing Personal Information
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    We share your Personal Information with service providers to
                    help us provide our services and fulfill our contracts with
                    you, as described above. For example:
                  </Text>
                  <UnorderedList>
                    <ListItem>
                      <Text type="small" my={2}>
                        We use Shopify to power our online store. You can read
                        more about how Shopify uses your Personal Information
                        here:{" "}
                        <Link
                          isExternal
                          href="https://www.shopify.com/legal/privacy"
                        >
                          {" "}
                          https://www.shopify.com/legal/privacy
                        </Link>{" "}
                        .
                      </Text>
                    </ListItem>
                    <ListItem>
                      <Text type="small" my={2}>
                        We may share your Personal Information to comply with
                        applicable laws and regulations, to respond to a
                        subpoena, search warrant or other lawful request for
                        information we receive, or to otherwise protect our
                        rights.
                      </Text>
                    </ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Behavioural Advertising
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    As described above, we use your Personal Information to
                    provide you with targeted advertisements or marketing
                    communications we believe may be of interest to you. For
                    example:
                    <UnorderedList>
                      <ListItem>
                        Meta (Facebook) pixel: We share information about your
                        use of the Site, your purchases, and your interaction
                        with our ads on other websites with our advertising
                        partners. We collect and share some of this information
                        directly with our advertising partners, and in some
                        cases through the use of cookies or other similar
                        technologies (which you may consent to, depending on
                        your location).
                      </ListItem>
                    </UnorderedList>
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Using Personal Information
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    We use your personal Information to provide our services to
                    you, which includes: offering products for sale, processing
                    payments, shipping and fulfillment of your order, and
                    keeping you up to date on new products, services, and
                    offers.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Lawful basis
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    Pursuant to the General Data Protection Regulation (“GDPR”),
                    if you are a resident of the European Economic Area (“EEA”),
                    we process your personal information under the following
                    lawful bases:
                  </Text>
                  <UnorderedList>
                    <ListItem>Your consent</ListItem>
                    <ListItem>
                      The performance of the contract between you and the Site
                    </ListItem>
                    <ListItem>Compliance with our legal obligations</ListItem>
                    <ListItem>To protect your vital interests</ListItem>
                    <ListItem>To perform a task</ListItem>
                    <ListItem>carried out in the public interest</ListItem>
                    <ListItem>
                      For our legitimate interests, which do not override your
                      fundamental rights and freedoms.
                    </ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Retention
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    When you place an order through the Site, we will retain
                    your Personal Information for our records unless and until
                    you ask us to erase this information. For more information
                    on your right of erasure, please see the ‘Your rights’
                    section below.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Automatic decision-making
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    If you are a resident of the EEA, you have the right to
                    object to processing based solely on automated
                    decision-making (which includes profiling), when that
                    decision-making has a legal effect on you or otherwise
                    significantly affects you.
                    <br />
                    <br />
                    We [DO/DO NOT] engage in fully automated decision-making
                    that has a legal or otherwise significant effect using
                    customer data.
                    <br />
                    <br />
                    Our processor Shopify uses limited automated decision-making
                    to prevent fraud that does not have a legal or otherwise
                    significant effect on you.
                    <br />
                    <br />
                    Services that include elements of automated decision-making
                    include:
                    <br />
                    <br />
                    <UnorderedList>
                      <ListItem>
                        Temporary blacklist of IP addresses associated with
                        repeated failed transactions. This blacklist persists
                        for a small number of hours.
                      </ListItem>
                      <ListItem>
                        Temporary blacklist of credit cards associated with
                        blacklisted IP addresses. This blacklist persists for a
                        small number of days.
                      </ListItem>
                    </UnorderedList>
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Selling Personal information
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    Our Site sells Personal Information, as defined by the
                    California Consumer Privacy Act of 2018 (“CCPA”).
                    <UnorderedList>
                      <ListItem>categories of information sold</ListItem>
                      <ListItem>
                        instructions on how to opt-out of sale
                      </ListItem>
                    </UnorderedList>
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Cookies
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    A cookie is a small amount of information that’s downloaded
                    to your computer or device when you visit our Site. We use a
                    number of different cookies, including functional,
                    performance, advertising, and social media or content
                    cookies. Cookies make your browsing experience better by
                    allowing the website to remember your actions and
                    preferences (such as login and region selection). This means
                    you don’t have to re-enter this information each time you
                    return to the site or browse from one page to another.
                    Cookies also provide information on how people use the
                    website, for instance whether it’s their first time visiting
                    or if they are a frequent visitor.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Do Not Track
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    Please note that because there is no consistent industry
                    understanding of how to respond to “Do Not Track” signals,
                    we do not alter our data collection and usage practices when
                    we detect such a signal from your browser.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Changes
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    We may update this Privacy Policy from time to time in order
                    to reflect, for example, changes to our practices or for
                    other operational, legal, or regulatory reasons.
                  </Text>
                </AccordionPanel>
              </AccordionItem>

              <AccordionItem>
                <h2>
                  <AccordionButton py={3}>
                    <Box flex="1" textAlign="left">
                      <HeadingChakra
                        fontSize="0.875rem"
                        color="#5C5C5C"
                        fontWeight="bold"
                      >
                        Complaints
                      </HeadingChakra>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Text type="small" mt={2}>
                    As noted above, if you would like to make a complaint,
                    please contact us by e-mail or by mail using the details
                    provided under “Contact” above.
                  </Text>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </Box>
        </Container>
      </PageLayout>
    </>
  )
}

export default Page
